export const GET_STATISTIC_SUCCESS = "GET_STATISTIC_SUCCESS"
export const GET_STATISTIC_FAIL = "GET_STATISTIC_FAIL"